import { playlistAPI } from "../../api/playlistAPI"
import { getPlayListAC, GET_PLAYLIST, isFetchingAC, IS_FETCHING } from "../actions/playlistActions"

let initialState = {
    playlist: null,
    isFetching: false
}

export const playlistReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PLAYLIST:
            return {
                ...state,
                playlist: action.playlist
            }
        case IS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching
            }
    }
    return state
}

export const getPlaylist = (artist) => async (dispatch) => {
    try {
        dispatch(isFetchingAC(true))
        const playlist = await playlistAPI.getPlaylist(artist)
        dispatch(getPlayListAC(playlist))
        dispatch(isFetchingAC(false))
    } catch (e) {
        throw e
    } finally {
        dispatch(isFetchingAC(false))
    }
}